import React, { Component } from 'react'
import { Field } from 'redux-form'
import DateSingle from './DateSingle'

class DateSingleInput extends Component {
  render() {
    if (this.props.source) {
      return <Field component={DateSingle} {...this.props} name={this.props.name ? this.props.name : this.props.source} />
    } else {
      return <DateSingle {...this.props} />
    }
  }
}

export default DateSingleInput
